import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Car, Sparkles } from "lucide-react";

const TYPE_LABEL = { sedan: "Sedan", suv: "SUV", van: "Van", bus: "Bus", electric_car: "Electric" };

export default function Fleet() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/vehicles").then((r) => setItems(r.data || []));
  }, []);

  const filtered = filter === "all" ? items : items.filter(v => v.type === filter);

  return (
    <div>
      <div className="flex items-end justify-between mb-5">
        <div>
          <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Vehicles</p>
          <h1 className="font-display font-bold text-3xl text-slate-900">Fleet</h1>
        </div>
        <span className="text-xs px-3 py-1.5 rounded-full bg-primary-50 text-primary-700 font-bold uppercase tracking-wider">{items.length} total</span>
      </div>

      <div className="flex gap-2 mb-4 overflow-x-auto no-scrollbar">
        {["all", "sedan", "suv", "van", "bus", "electric_car"].map(t => (
          <button
            key={t}
            data-testid={`fleet-filter-${t}`}
            onClick={() => setFilter(t)}
            className={`px-4 h-9 rounded-full text-xs font-bold uppercase tracking-wider transition-all ${filter === t ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            {t === "all" ? "All" : TYPE_LABEL[t] || t}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              {["Plate", "Type", "Make/Model", "Year", "Color", "Capacity", "Status"].map(h => (
                <th key={h} className="text-left text-[11px] uppercase tracking-wider text-slate-500 font-bold px-5 py-3 border-b border-slate-200">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(v => (
              <tr key={v.id} data-testid={`fleet-row-${v.id}`} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-5 py-3 text-sm font-mono font-semibold text-slate-900">{v.plate_number}</td>
                <td className="px-5 py-3 text-sm">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-50 text-primary-700 font-bold uppercase tracking-wider">
                    {TYPE_LABEL[v.type] || v.type}
                  </span>
                </td>
                <td className="px-5 py-3 text-sm font-semibold text-slate-900 flex items-center gap-2">
                  {v.type === "electric_car" ? <Sparkles size={14} className="text-primary" /> : <Car size={14} className="text-slate-400" />}
                  {v.make} {v.model}
                </td>
                <td className="px-5 py-3 text-sm text-slate-700">{v.year}</td>
                <td className="px-5 py-3 text-sm text-slate-700">{v.color}</td>
                <td className="px-5 py-3 text-sm text-slate-700">{v.capacity}</td>
                <td className="px-5 py-3"><span className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 font-bold uppercase tracking-wider">{v.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
